import React, { useState } from 'react'
import { Menu, Button } from 'antd'
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    ClusterOutlined,
    DatabaseOutlined,
    BuildOutlined,
    AudioOutlined,
} from '@ant-design/icons'
import { Container, CollapseButton } from './Styled'
import { isAuthorized, Role } from '../../helpers/rolesHelper'
import { useSelector } from 'react-redux'
import { selectUserRoles } from '../../business/selectors/userSelectors'

export enum MenuKeys {
    flows = 'flows',
    intents = 'intents',
    entities = 'entities',
    tts = 'tts',
}

type NavigationMenuProps = {
    onSelect: (key: string) => void
}

export const NavigationMenu: React.FunctionComponent<NavigationMenuProps> = ({
    onSelect,
}) => {
    const [collapsed, setCollapsed] = useState(true)
    const userRoles: string | string[] = useSelector(selectUserRoles)

    const toggleCollapsed = () => {
        setCollapsed(!collapsed)
    }

    return (
        <Container>
            <Menu
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                mode="inline"
                theme="dark"
                onSelect={({ key }) => onSelect(key.toString())}
                inlineCollapsed={collapsed}
            >
                 <Menu.Item key={MenuKeys.flows}>
                        <ClusterOutlined />
                        <span>Flows</span>
                    </Menu.Item>
                    <Menu.Item key={MenuKeys.intents}>
                        <DatabaseOutlined />
                        <span>Intents Library</span>
                    </Menu.Item>
                    <Menu.Item key={MenuKeys.entities}>
                        <BuildOutlined />
                        <span>Entities Library</span>
                    </Menu.Item>
                    <Menu.Item key={MenuKeys.tts}>
                        <AudioOutlined />
                        <span>Text to speech</span>
                    </Menu.Item>
            </Menu>
            <CollapseButton>
                <Button type="primary" onClick={toggleCollapsed}>
                    {React.createElement(
                        collapsed ? MenuUnfoldOutlined : MenuFoldOutlined
                    )}
                </Button>
            </CollapseButton>
        </Container>
    )
}

export default NavigationMenu
